import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { inquiryService } from 'services';

const initialState = {
  data: {},
  detailData: {},
  filter: {
    dateCreated: '',
    identityNo: '',
    name: '',
    status: '',
    referenceNumber: '',
  },
  statusList: 'idle',
  statusDetail: '',
};

export const getListEkycAction = createAsyncThunk(
  'inquiry/getListEkyc',
  async (payload) => {
    const res = await inquiryService.getListEkyc(payload);
    return res;
  },
);

export const getDetailEkycAction = createAsyncThunk(
  'inquiry/getDetailEkyc',
  async (id) => {
    const res = await inquiryService.getDetailEkyc(id);
    return res;
  },
);

export const inquiryEkycSlice = createSlice({
  name: 'inquiry',
  initialState: initialState,
  reducers: {
    setFilter: (state, action) => {
      const data = action.payload;
      state.filter = data;
    },
    resetAllData: () => {
      return initialState;
    },
    resetData: (state, action) => {
      const payload = action.payload;
      if (typeof payload === 'string') {
        state[payload] = initialState[payload];
      } else if (Array.isArray(payload)) {
        payload.forEach((item) => (state[item] = initialState[item]));
      }
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getListEkycAction.pending, (state) => {
        state.statusList = 'loading';
      })
      .addCase(getListEkycAction.fulfilled, (state, action) => {
        state.statusList = 'success';
        state.data = action.payload;
      })
      .addCase(getListEkycAction.rejected, (state) => {
        state.statusList = 'error';
      })
      .addCase(getDetailEkycAction.pending, (state) => {
        state.statusDetail = 'loading';
      })
      .addCase(getDetailEkycAction.fulfilled, (state, action) => {
        state.statusDetail = 'success';
        state.detailData = action.payload;
      })
      .addCase(getDetailEkycAction.rejected, (state) => {
        state.statusDetail = 'error';
      });
  },
});

export const { setFilter, resetAllData, resetData } = inquiryEkycSlice.actions;

const inquiryEkycReducer = inquiryEkycSlice.reducer;
export default inquiryEkycReducer;